module.exports = __webpack_public_path__ + "img/reset.2d551328.png";